/* eslint-disable no-template-curly-in-string */

import { ComponentProps, ReactPropTypes, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import QuillDelta from 'quill-delta';
import { useDebouncedCallback } from 'use-debounce';

import FormErrorMessage from '../forms/errors/FormErrorMessage';

import QuillEditor from './QuillEditor';

export default function QuillField({
	name,
	...props
}: ComponentProps<typeof QuillEditor> & {
	name: string;
}) {
	const [field, { value, error }, { setValue }] = useField<QuillDelta>(name);
	const { t } = useTranslation();

	return (
		<>
			<QuillEditor
				{...props}
				value={props.value ?? (value || { ops: [] })}
				onChange={(value) => setValue(value)}
			/>
			{error && (
				<FormErrorMessage
					error={
						new Error(
							t('validation.mixed.required').replace('${path}', t(`common.fields.${field.name}`)),
						)
					}
				/>
			)}
		</>
	);
}
